import React from 'react';
import {useSelector} from "react-redux";

const CardInfo = ({date, name_client, phone, status, title, address, id_task, comment}) => {

    const link = `https://m-k.bitrix24.ru/crm/lead/details/${id_task}/`

    const {admin} = useSelector(state => state.main)

    return (
        <td className={'border border-black inline-block px-6 py-4 w-full box-border bg-amber-100 mt-2'}>
            {(admin) ? <a
                target="_blank"
                href={link}
                className="text-md font-bold"
            >
                Название: {title}
            </a> : <div className={'text-md'}>Дата: {title}</div>}
            <div className={'text-md'}>Дата: <strong>{date}</strong></div>
            <div className={'text-md'}>Имя клиента: {name_client}</div>
            <div className={'text-md'}>Телефон: {phone}</div>
            <div className={'text-md'}>Адрес: {address}</div>
            <div className={'text-md'}>Статус: {status}</div>
            <div className={'text-md'}>Комментарий: {comment}</div>
        </td>
    );
};

export default CardInfo;